<div
  class="fc-outlined-select"
  [class.invalid]="control.touched && control.invalid"
  [class.disabled]="control.disabled"
>
  <div class="fc-outlined-select__infix" [class.float-label]="control.value" (click)="openOptionsList()">
    <label *ngIf="label" class="fc-outlined-select__infix-label">
      {{ label }}
      <span *ngIf="required && !selectedValue">*</span>
    </label>
    <p class="fc-outlined-select__infix-input" matTooltip="{{ selectedValue }}" [matTooltipPosition]="'above'">
      {{ selectedValue }}
    </p>
    <small class="fc-outlined-select__infix-error" *ngIf="control.touched && control.invalid">
      <ng-content></ng-content>
    </small>
  </div>

  <div class="fc-outlined-select__suffix" (click)="openOptionsList()">
    <mat-icon
      class="fc-outlined-select__suffix-drop-down"
      [ngClass]="{ 'fc-outlined-select__suffix-drop-down--selected': showOptions }"
    >
      arrow_drop_down
    </mat-icon>
  </div>

  <ul
    *ngIf="showOptions"
    class="fc-outlined-select__options"
    [class.fc-outlined-select__options--above]="isOptionsAbove"
    @fade
    (scroll)="handleScroll($event)"
  >
    <li class="fc-outlined-select__search-container" *ngIf="!predefinedOptions.length">
      <mat-icon>search</mat-icon>
      <input
        type="text"
        class="fc-outlined-select__infix-text-input"
        [placeholder]="'FC_OUTLINED_SELECT.SEARCH_PLACEHOLDER' | translate"
        [formControl]="textInputForm"
        (blur)="onBlur()"
      />
      <img src="assets/images/icons/cancel.svg" (click)="clearTextAndSelection()" />
    </li>

    <li
      *ngFor="let option of options"
      class="fc-outlined-select__options_option"
      (click)="selectOption(option)"
      [ngClass]="{ 'fc-outlined-select__options_option--selected': option.value === control.value }"
      [class.disabled]="alreadySelected.includes(option.value)"
      (click)="!alreadySelected.includes(option.value) ? selectOption(option) : null"
      [matTooltip]="alreadySelected.includes(option.value) ? ('FC_OUTLINED_SELECT.ALREADY_SELECTED' | translate) : null"
      [matTooltipDisabled]="!alreadySelected.includes(option.value)"
      matRipple
    >
      <p class="fc-outlined-select__options_option__text">{{ option.text }}</p>
    </li>

    <li *ngIf="!options.length" class="fc-outlined-select__options_option">
      <p class="fc-outlined-select__options__no-result">
        {{ 'FC_OUTLINED_SELECT.NO_RESULTS' | translate }}
      </p>
    </li>
  </ul>
</div>
